
import React from 'react';
import { Outlet } from 'react-router-dom';

const PublicLayout = () => {
    return (
        <div className="min-h-screen bg-background text-foreground">
            <Outlet />
        </div>
    );
};

export default PublicLayout;
